<template>
  <div class="row">
    <div class="col-12 d-flex">
      <h2>{{ $t('contracts.contract', 2).capitalize() }}</h2>
      <div class="ms-3" v-if="client_id">
        <router-link class="btn btn-primary btn-sm" :to="{name: ROUTES.CONTRACTS.CREATE, query:{ client_id }}">
          <i class="fa-solid fa-circle-plus"></i> {{ $t('contracts.create.headline') }}
        </router-link>
      </div>
    </div>
    <div class="col-12">
      <ContractsTable :paginator="true"
                      :client_id="client_id"
                      :show-filters="true"
                      :rows="contractStore.serverOptions.rows"
                      :totalRecords="contractStore.itemLength"
                      dataKey="id"
                      :value="contractStore.contracts"
                      :loading="contractStore.loading"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      :rowsPerPageOptions="setupStore.dataTableDefaults.rowsPerPageOptions"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      responsiveLayout="scroll">
      </ContractsTable>
    </div>
  </div>
</template>

<script>

import {useContractStore} from "@/stores/contract";
import {useSetupStore} from "@/stores/setup";
import ContractsTable from "@/components/tables/ContractsTable.vue";
import {ROUTES} from "@/scripts/constants";

export default {
  name: 'ContractsIndex',
  components: {
    ContractsTable,
  },
  setup() {
    return {
      contractStore: useContractStore(),
      setupStore: useSetupStore(),
    }
  },
  props: {
    client_id: {
      type: Number,
      default: null,
    },
  },
  created() {
    this.setTitle(this.$t('contracts.contract', 2).capitalize())
  },
  computed: {
    ROUTES() {
      return ROUTES
    }
  },
}
</script>
